import { LegalPage } from "@/components/LegalPage";

const INTRO = [
  "Welcome to SYNAPHY (\u201cSYNAPHY\u201d, \u201cwe\u201d, \u201cus\u201d, or \u201cour\u201d).",
  "These Terms of Use (\u201cTerms\u201d) govern your access to and use of synaphy.com and the pre-launch services, registration forms, community pages and related materials made available by SYNAPHY (collectively, the \u201cWebsite\u201d).",
  "By accessing or using the Website, you acknowledge that you have read and understood these Terms.",
];

const SECTIONS = [
  {
    title: "About SYNAPHY",
    paragraphs: [
      "SYNAPHY is currently in its pre-launch phase.",
      "The Website is primarily intended to:",
      "Some features, products, applications and network functionality described on the Website may still be under development and may change before launch.",
    ],
    list: [
      "Introduce the SYNAPHY vision and technology;",
      "Build an early community;",
      "Collect expressions of interest;",
      "Provide information about upcoming products and programs;",
      "Communicate future launch opportunities.",
    ],
  },
  {
    title: "Pre-Launch Status",
    paragraphs: [
      "Information published on the Website regarding future products, applications, Founding, contributors, network infrastructure, AI systems, physical-world intelligence or other planned functionality represents the current development vision and should not be interpreted as a guarantee that any particular feature will launch in its described form.",
      "SYNAPHY may modify, postpone, discontinue or replace planned features at any time.",
    ],
  },
  {
    title: "No Guarantee of Launch",
    paragraphs: [
      "Registration for the SYNAPHY pre-launch community, waitlist or interest list does not guarantee:",
      "Access to future programs may be subject to separate eligibility requirements and terms.",
    ],
    list: [
      "Access to a future product;",
      "Founding membership;",
      "Pilot network access;",
      "Production network access;",
      "Contributor status;",
      "Any reward;",
      "Any financial benefit.",
    ],
  },
  {
    title: "No Investment Offer",
    paragraphs: [
      "Nothing on the Website constitutes:",
      "Any future reward, membership, contributor or commercial program will be governed by separate terms where applicable.",
    ],
    list: [
      "An offer to sell securities;",
      "An investment recommendation;",
      "Financial advice;",
      "A guarantee of profit or return;",
      "A promise of future value of any kind;",
      "An offer to purchase any financial instrument or digital asset.",
    ],
  },
  {
    title: "Pre-Launch Registration",
    paragraphs: [
      "Where the Website allows you to register interest, you agree to provide information that is accurate and not misleading.",
      "You must not:",
      "SYNAPHY may remove fraudulent or duplicate registrations.",
    ],
    list: [
      "Register using another person's identity;",
      "Create fraudulent accounts;",
      "Submit automated or spam registrations;",
      "Manipulate referral or registration systems;",
      "Attempt to obtain multiple benefits through duplicate identities.",
    ],
  },
  {
    title: "Community Conduct",
    paragraphs: ["Users must not use the Website to:"],
    list: [
      "Misrepresent SYNAPHY;",
      "Make unauthorized promises on behalf of SYNAPHY;",
      "Claim to be an employee, founder, representative or authorized agent without permission;",
      "Spread deliberately false information about SYNAPHY;",
      "Attack or compromise Website infrastructure;",
      "Upload malicious code;",
      "Attempt unauthorized access;",
      "Abuse registration or referral mechanisms.",
    ],
  },
  {
    title: "Intellectual Property",
    paragraphs: [
      "Unless otherwise stated, the SYNAPHY name, logos, designs, graphics, text, software, concepts, branding and Website content are owned by or licensed to SYNAPHY.",
      "You may not reproduce, modify, distribute, sell or commercially exploit SYNAPHY intellectual property without prior written permission.",
      "Participation in the pre-launch community does not grant ownership of SYNAPHY intellectual property.",
    ],
  },
  {
    title: "Third-Party Links",
    paragraphs: [
      "The Website may contain links to third-party websites or services.",
      "SYNAPHY does not control those third-party services and is not responsible for their content, availability, security or privacy practices.",
      "Your use of third-party services is subject to their own terms.",
    ],
  },
  {
    title: "Website Availability",
    paragraphs: [
      "We may modify, suspend or discontinue portions of the Website without notice.",
      "We do not guarantee that the Website will always be:",
    ],
    list: [
      "Available;",
      "Error-free;",
      "Secure;",
      "Uninterrupted; or",
      "Free from technical defects.",
    ],
  },
  {
    title: "Future Products and Services",
    paragraphs: [
      "SYNAPHY may introduce products or services involving technologies such as:",
      "Such products will be governed by additional terms applicable to those products when launched.",
    ],
    list: [
      "Artificial intelligence;",
      "Computer vision;",
      "Physical-world intelligence;",
      "Consumer applications;",
      "Contributor networks;",
      "Location technologies;",
      "Camera/image processing;",
      "Pilot networks or other network infrastructure.",
    ],
  },
  {
    title: "Disclaimer",
    paragraphs: [
      "The Website and its pre-launch information are provided on an \u201cas available\u201d basis.",
      "SYNAPHY makes no guarantee regarding the accuracy, completeness or future availability of information concerning products or features that are still under development.",
      "Nothing on the Website should be interpreted as a guarantee of commercial success, income, rewards, investment returns or future asset value.",
    ],
  },
  {
    title: "Limitation of Liability",
    paragraphs: [
      "To the extent permitted by applicable law, SYNAPHY will not be responsible for losses arising solely from:",
      "Nothing in these Terms excludes liability that cannot legally be excluded under applicable law.",
    ],
    list: [
      "Reliance on future product descriptions;",
      "Temporary Website unavailability;",
      "Third-party services;",
      "User-generated content;",
      "Unauthorized use of an account;",
      "Events outside our reasonable control.",
    ],
  },
  {
    title: "Changes to These Terms",
    paragraphs: [
      "We may update these Terms as SYNAPHY develops.",
      "Updated Terms will be published on this page with a revised \u201cLast Updated\u201d date.",
      "Your continued use of the Website after an update constitutes acceptance of the revised Terms to the extent permitted by applicable law.",
    ],
  },
  {
    title: "Governing Law",
    paragraphs: [
      "These Terms will be governed by the applicable laws of Delaware/California, subject to applicable jurisdictional requirements.",
      "Any dispute will be subject to the jurisdiction of the courts having appropriate jurisdiction over the relevant matter.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      title="Pre-Launch Terms of Use"
      intro={INTRO}
      sections={SECTIONS}
    />
  );
}
